module.exports = __webpack_public_path__ + "static/media/5.c79241b1.jpg";